import MaternityProductCards from '../MaternityProductCards';
import { ProductListContainer } from './styled';

export default function ProductList(props) {
  const {
    items,
    setShowSizePopup,
    setProductId,
    sectionId,
    setEventsData,
    type,
    userType,
    setAddedToCart,
    categoryName,
    statusOfIds,
    index,
  } = props;

  return (
    <ProductListContainer userType={userType}>
      {items?.map((item, idx) => {
        return (
          <MaternityProductCards
            userType={userType}
            item={item}
            key={`product${idx}`}
            index={idx}
            setShowSizePopup={setShowSizePopup}
            setProductId={setProductId}
            sectionId={sectionId}
            setEventsData={setEventsData}
            type={type}
            setAddedToCart={setAddedToCart}
            categoryName={categoryName}
            statusOfIds={statusOfIds}
            outerIndex={index}
          />
        );
      })}
    </ProductListContainer>
  );
}
